module.exports = __webpack_public_path__ + "fc06371e0dec2fd932d281e74a2c95d4.pdf";